module.exports = __webpack_public_path__ + "static/ods-d182bacc16a89e51fc2e99dea088f0cd.png";